module.exports = __webpack_public_path__ + "img/press-11.d8e83b24.jpeg";